import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tagsinput/react-tagsinput.css";

ReactDOM.render(
	<BrowserRouter>
		<React.StrictMode>
			<ToastContainer
				autoClose={false}
				position="top-right"
				closeOnClick={true}
				pauseOnHover={true}
				pauseOnFocusLoss={false}
			/>
			<div id="custom-modal" />
			<App />
		</React.StrictMode>
	</BrowserRouter>,
	document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
